/**
 * Copies text to the clipboard.
 * navigator.clipboard only exists in secure contexts (https or localhost), so on
 * plain http (like the local sandbox) it falls back to a temporary textarea.
 * Rejects with the text in the message when both ways fail, so it can be copied by hand.
 */
export async function copyToClipboard(text) {
    if (window.isSecureContext && navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    let copied = false;
    try {
        copied = document.execCommand('copy');
    } finally {
        document.body.removeChild(textarea);
    }

    if (!copied) throw new Error(`Could not copy. Copy it manually: ${text}`);
}
